module.exports = __webpack_public_path__ + "static/media/campus-food-truck-catering-4.bb6ec7f0.jpeg";